import React, { useReducer } from 'react';
import { WarboxMessageContext } from './warboxMessageContext';
import warboxMessageReducer from './warboxMessageReducer';
import { DEFAULT_WARBOX_MESSAGE_STATE } from './constants/defaultState';
import { clearState, setLoading } from '../utils';
import { IWarboxMessageState } from './types';
import {
    getMessages,
    getMessagesByConversation,
    sendTemplateMessage,
    sendTextMessage,
    updateNoteMessage,
    deleteNoteMessage,
    clearConversationMessages,
} from './utils';
import { UPSERT_WARBOX_MESSAGE } from './constants/actions';

export const WarboxMessageState = ({ children }: IWarboxMessageState) => {
    const [state, dispatch] = useReducer(
        warboxMessageReducer,
        DEFAULT_WARBOX_MESSAGE_STATE
    );

    return (
        <WarboxMessageContext.Provider
            value={{
                ...state,
                clearState: () =>
                    clearState(dispatch, DEFAULT_WARBOX_MESSAGE_STATE),
                setLoading: () => setLoading(dispatch),
                getMessagesByConversation: (conversationId, filters, options) =>
                    getMessagesByConversation(
                        dispatch,
                        conversationId,
                        filters,
                        options
                    ),
                getMessages: (filters, options) =>
                    getMessages(dispatch, filters, options),
                sendTextMessage: (payload) =>
                    sendTextMessage(dispatch, payload),
                sendTemplateMessage: (payload) =>
                    sendTemplateMessage(dispatch, payload),
                upsertMessage: (message) =>
                    dispatch({
                        type: UPSERT_WARBOX_MESSAGE,
                        payload: message,
                    }),
                updateNoteMessage: (messageId, message) =>
                    updateNoteMessage(dispatch, messageId, message),
                deleteNoteMessage: (messageId) =>
                    deleteNoteMessage(dispatch, messageId),
                clearConversationMessages: (conversationId) =>
                    clearConversationMessages(dispatch, conversationId),
            }}
        >
            {children}
        </WarboxMessageContext.Provider>
    );
};
